import MuiDeleteIcon from '@mui/icons-material/Delete';
import { SvgIconProps } from '@mui/material';

export const DeleteIcon = (props: SvgIconProps) => <MuiDeleteIcon {...props} />;
